module.exports = {"title":"Blog","body":"<h1>Coming soon</h1>\n"}


//////////////////
// WEBPACK FOOTER
// ./blog/index.md
// module id = 586
// module chunks = 0